export function formatTextSectionLabel(title: string, sectionTextLabel: string): string {
  const sectionNumberMatch = title.match(/^(\d+(?:\.\d+)*)\.?\s+/)
  const sectionNumber = sectionNumberMatch?.[1]
  return sectionNumber ? `${sectionNumber}. ${sectionTextLabel}` : sectionTextLabel
}
